import { render, staticRenderFns } from "./publicLecture.vue?vue&type=template&id=35648818&scoped=true"
import script from "./publicLecture.vue?vue&type=script&lang=js"
export * from "./publicLecture.vue?vue&type=script&lang=js"
import style0 from "./publicLecture.vue?vue&type=style&index=0&id=35648818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35648818",
  null
  
)

export default component.exports